import { act_com } from '@lc/action/cardType/Common';
import {
	batteryReductionOneTurn,
	factoryReductionOneTurn,
} from '@lc/const/modifiers';
import { GameState } from '@lc/interface/gameState/types';
import { act_player } from '@lc/interface/player/action';
import { Player } from '@lc/interface/player/types';
import { getPlayerStateWithId } from '@lc/lib/player_helper';
import { energyColors } from '@lc/types/Misc';

class NewsAction {
	ancientAlien(gameState: GameState) {
		let lowestBatteries = Infinity;
		let playerIdsWithLowestBatteries: number[] = [];
		const players = gameState.playerStateArray;

		for (const player of players) {
			if (player.batteries < lowestBatteries) {
				lowestBatteries = player.batteries;
				playerIdsWithLowestBatteries = [player.playerId];
			} else if (player.batteries === lowestBatteries) {
				playerIdsWithLowestBatteries.push(player.playerId);
			}
		}

		if (players.length <= playerIdsWithLowestBatteries.length) {
			return; // tie you die
		}

		for (const id of playerIdsWithLowestBatteries) {
			players[id].modifiers.push(batteryReductionOneTurn);
		}
	}

	artOfSteal(gameState: GameState) {
		console.log('ART OF STEAL');
		if (gameState.carbonReservoir >= gameState.numPlayers) {
			for (const player of gameState.playerStateArray) {
				gameState.carbonReservoir--;
				player.carbonFootprint++;
			}
		} else {
			for (const player of gameState.playerStateArray) {
				const energyTally = act_player.stealEnergy(player, 2);

				for (const e of energyTally) {
					player.donationCupArr.push(e);
				}
			}
		}
	}

	badPublicity(gameState: GameState) {
		for (const player of gameState.playerStateArray) {
			const prAmount = player.prArr.length;

			while (player.factoryEnergyArr.length > prAmount) {
				player.factoryEnergyArr.pop();
			}
		}
	}

	chemtrails(gameState: GameState) {
		for (const player of gameState.playerStateArray) {
			const energyTally = act_player.stealEnergy(player, 2);

			for (const e of energyTally) {
				player.donationCupArr.push(e);
			}
		}
	}

	commonCold(gameState: GameState) {
		for (const player of gameState.playerStateArray) {
			if (player.batteries > 0 && player.batteryEnergyArr.length > 0) {
				for (const e in player.batteryEnergyArr) {
					// add 1 donation per filled battery
					player.donationCupArr.push(e);
				}

				player.batteryEnergyArr = [];
				act_player.refillAllBatteries(player);
			}
		}
	}

	cryptocurrencyMine(gameState: GameState) {
		let highestCF = 0;
		let playerIdsWithHighestCF: number[] = [];
		const players = gameState.playerStateArray;

		for (const player of players) {
			if (player.carbonFootprint > highestCF) {
				highestCF = player.carbonFootprint;
				playerIdsWithHighestCF = [player.playerId];
			} else if (player.carbonFootprint === highestCF) {
				playerIdsWithHighestCF.push(player.playerId);
			}
		}

		if (highestCF === 0) {
			return;
		}

		if (playerIdsWithHighestCF.length === gameState.numPlayers) {
			return;
		}

		// iterating through turn order, each player with energy "sends"
		// to neighbors who can take it

		function sendEnergyToPlayerIfBatteryPresent(
			playerId: number,
			targetId: number
		) {
			const pState = getPlayerStateWithId(players, playerId);
			const tState = getPlayerStateWithId(players, targetId);

			if (tState.batteries <= tState.batteryEnergyArr.length) {
				return;
			}

			if (pState.factoryEnergyArr.length > 0) {
				tState.batteryEnergyArr.push(
					pState.factoryEnergyArr.pop() || 'y'
				); // 'y' is from typescript complaining
			} else if (pState.batteryEnergyArr.length > 0) {
				tState.batteryEnergyArr.push(
					pState.batteryEnergyArr.pop() || 'y'
				); // same
			}
		}

		for (
			let i = 0;
			i < gameState.currentTurnTypePlayerTableOrder.length;
			i++
		) {
			const currPlayerId = gameState.currentTurnTypePlayerTableOrder[i];

			if (!playerIdsWithHighestCF.includes(currPlayerId)) {
				continue;
			}

			const [lId, cId, rId] = act_com.createNeighborIdArray(
				{ playerId: currPlayerId },
				players
			);

			sendEnergyToPlayerIfBatteryPresent(currPlayerId, lId);
			sendEnergyToPlayerIfBatteryPresent(currPlayerId, rId);
		}
	}

	dadsAgainstElectric(gameState: GameState) {
		gameState.turnOrder = gameState.turnOrder.reverse();
	}

	darkSideOfMoon(gameState: GameState) {
		const players = gameState.playerStateArray;

		for (const p of players) {
			if (p.batteries > 0 && p.batteryEnergyArr.length > 0) {
				p.modifiers.push(factoryReductionOneTurn);
			}
		}
	}

	electricCarDead(gameState: GameState) {
		for (const player of gameState.playerStateArray) {
			let tab = player.carbonFootprint;

			while (tab > 0 && player.prArr.length > 0) {
				player.prArr.pop();
				tab--;
			}

			while (tab > 0 && player.batteries > 0) {
				act_player.deleteBattery(player);
				tab--;
			}
		}
	}

	findingNucleus(gameState: GameState) {
		let highestCF = 0;
		let playersWithHighestCF: Player[] = [];

		for (const player of gameState.playerStateArray) {
			if (player.carbonFootprint > highestCF) {
				highestCF = player.carbonFootprint;
				playersWithHighestCF = [player];
			} else if (player.carbonFootprint === highestCF) {
				playersWithHighestCF.push(player);
			}
		}

		if (highestCF === 0) {
			return;
		}

		// if(playersWithHighestCF.length === gameState.numPlayers){
		//     return;
		// }

		for (const player of playersWithHighestCF) {
			player.factoryEnergyArr = [];
			act_player.refillAllBatteries(player);
		}
	}

	fracking(gameState: GameState) {
		let lowestPR = Infinity,
			highestCF = 0;

		for (const player of gameState.playerStateArray) {
			lowestPR = Math.min(lowestPR, player.prArr.length);
			highestCF = Math.max(highestCF, player.carbonFootprint);
		}

		if (lowestPR === 0 && highestCF === 0) return;

		for (const player of gameState.playerStateArray) {
			if (
				player.carbonFootprint === highestCF &&
				player.prArr.length === lowestPR
			) {
				act_player.deleteFactory(player);
			} else if (
				player.carbonFootprint === highestCF ||
				player.prArr.length === lowestPR
			) {
				act_player.deleteBattery(player);
			}
		}
	}

	freeChargedBattery(gameState: GameState) {
		for (const player of gameState.playerStateArray) {
			act_player.buyBattery(player);
			act_player.refillBattery(player);
		}
	}

	gasGiant(gameState: GameState) {
		let lowestPR = Infinity;
		let playersWithLowestPR: Player[] = [];

		for (const player of gameState.playerStateArray) {
			const pr = player.prArr.length;
			if (pr < lowestPR) {
				lowestPR = pr;
				playersWithLowestPR = [player];
			} else if (pr === lowestPR) {
				playersWithLowestPR.push(player);
			}
		}

		if (playersWithLowestPR.length === gameState.numPlayers) {
			return;
		}

		if (playersWithLowestPR.length * 2 > gameState.carbonReservoir) {
			for (const player of gameState.playerStateArray) {
				act_player.deleteFactory(player);
			}
		} else {
			for (const player of playersWithLowestPR) {
				gameState.carbonReservoir -= 2;
				player.carbonFootprint += 2;
			}
		}
	}

	genderReveal(gameState: GameState) {
		let highestPR = 0;

		for (const player of gameState.playerStateArray) {
			highestPR = Math.max(highestPR, player.prArr.length);
		}

		if (highestPR === 0) return;

		for (const player of gameState.playerStateArray) {
			if (player.prArr.length === highestPR) {
				act_player.refillAllBatteries(player);
			}
		}
	}

	glacierNational(gameState: GameState) {
		const numPlayers = gameState.numPlayers;
		for (let i = 0; i < numPlayers; i++) {
			let color: energyColors;
			if (i === numPlayers - 1) {
				color = gameState.playerStateArray[0].energyColor;
			} else {
				color = gameState.playerStateArray[i + 1].energyColor;
			}
			act_player.refillFactories(gameState.playerStateArray[i], color);
		}
	}

	gluten(gameState: GameState) {
		for (const player of gameState.playerStateArray) {
			if (player.prArr.length < 4) {
				if (player.factoryEnergyArr.length > 0)
					player.factoryEnergyArr.pop();
				if (player.factoryEnergyArr.length > 0)
					player.factoryEnergyArr.pop();
			}
		}
	}

	greatLandfills(gameState: GameState) {
		let lowestPR = Infinity;
		let playersWithLowestPR: number[] = [];
		const players = gameState.playerStateArray;

		for (const player of players) {
			const pr = player.prArr.length;
			if (pr < lowestPR) {
				lowestPR = pr;
				playersWithLowestPR = [player.playerId];
			} else if (pr === lowestPR) {
				playersWithLowestPR.push(player.playerId);
			}
		}

		if (playersWithLowestPR.length === gameState.numPlayers) {
			return;
		}

		for (
			let i = 0;
			i < gameState.currentTurnTypePlayerTableOrder.length;
			i++
		) {
			const currPlayerId = gameState.currentTurnTypePlayerTableOrder[i];
			if (!playersWithLowestPR.includes(currPlayerId)) {
				continue;
			}

			const [lId, cId, rId] = act_com.createNeighborIdArray(
				{ playerId: currPlayerId },
				players
			);

			if (players[lId].carbonFootprint > 0) {
				players[lId].carbonFootprint--;
				players[currPlayerId].carbonFootprint++;
			}

			if (players[rId].carbonFootprint > 0) {
				players[rId].carbonFootprint--;
				players[currPlayerId].carbonFootprint++;
			}
		}
	}

	greatPacificGarbagePatch(gameState: GameState) {
		let mostCompletedContracts = 0;
		let playersIdsMostCompletedContracts: number[] = [];
		const players = gameState.playerStateArray;

		for (const player of players) {
			const cc = player.completedContracts.length;
			if (cc > mostCompletedContracts) {
				mostCompletedContracts = cc;
				playersIdsMostCompletedContracts = [player.playerId];
			} else if (cc === mostCompletedContracts) {
				playersIdsMostCompletedContracts.push(player.playerId);
			}
		}

		if (playersIdsMostCompletedContracts.length === gameState.numPlayers) {
			return;
		}

		for (const id of playersIdsMostCompletedContracts) {
			players[id].modifiers.push(factoryReductionOneTurn);
		}
	}

	hottestYear(gameState: GameState) {
		for (const player of gameState.playerStateArray) {
			if (player.factoryEnergyArr.length >= 1)
				player.factoryEnergyArr.pop();
		}
	}

	insiderTrading(gameState: GameState) {
		const tempSeasonalHands: number[][] = [];
		const players = gameState.playerStateArray;
		for (let i = 0; i < players.length; i++) {
			tempSeasonalHands.push([...players[i].seasonalCards]);
		}

		const hand1 = tempSeasonalHands.shift();
		tempSeasonalHands.push(hand1 || []);

		for (let i = 0; i < players.length; i++) {
			gameState.playerStateArray[i].seasonalCards =
				tempSeasonalHands.shift() || [1000]; // if you see card 1000 you messed up
		}
	}

	lastWhale(gameState: GameState) {
		if (gameState.carbonReservoir < gameState.numPlayers) {
			return;
		}
		for (const player of gameState.playerStateArray) {
			gameState.carbonReservoir--;
			player.carbonReserve++;
		}
	}

	// iterate through player order, check if player has PR status, if so steal
	// do i have lowest PR? get list of players with same lowest PR
	// iterate through players. if on the lowest PR list, take a PR from neighbors
	misinformationAge(gameState: GameState) {
		const players = gameState.playerStateArray;

		function stealPrFromMorePopularTarget(
			playerId: number,
			targetId: number
		) {
			const pState = getPlayerStateWithId(
				gameState.playerStateArray,
				playerId
			);
			const tState = getPlayerStateWithId(
				gameState.playerStateArray,
				targetId
			);

			// just in case things get weird with taking pr
			if (tState.prArr.length > 0) {
				pState.prArr.push(tState.prArr.pop() || 'y');
			}
		}

		let lowestPR = Infinity;
		let playerIdsWithLowestPR: number[] = [];

		for (const player of gameState.playerStateArray) {
			const pr = player.prArr.length;
			if (pr < lowestPR) {
				lowestPR = pr;
				playerIdsWithLowestPR = [player.playerId];
			} else if (pr === lowestPR) {
				playerIdsWithLowestPR.push(player.playerId);
			}
		}

		if (playerIdsWithLowestPR.length === gameState.numPlayers) {
			return;
		}

		for (
			let i = 0;
			i < gameState.currentTurnTypePlayerTableOrder.length;
			i++
		) {
			const pId = gameState.currentTurnTypePlayerTableOrder[i];
			if (playerIdsWithLowestPR.includes(pId)) {
				// has lowest PR, steal neighbor's carbon
				const [lId, cId, rId] = act_com.getNeighborPlayerIds(
					pId,
					players
				);

				stealPrFromMorePopularTarget(i, lId);
				stealPrFromMorePopularTarget(i, rId);
			}
		}
	}

	nannyState(gameState: GameState) {
		let lowestFactories = Infinity;
		let playerIdsWithLowestFactories: number[] = [];
		const players = gameState.playerStateArray;

		for (const player of players) {
			if (player.factories < lowestFactories) {
				lowestFactories = player.factories;
				playerIdsWithLowestFactories = [player.playerId];
			} else if (player.factories === lowestFactories) {
				playerIdsWithLowestFactories.push(player.playerId);
			}
		}

		if (players.length === playerIdsWithLowestFactories.length) {
			return; // tie you die
		}

		for (const id of playerIdsWithLowestFactories) {
			const pState = getPlayerStateWithId(players, id);
			pState.modifiers.push(factoryReductionOneTurn);
		}
	}

	netMetering(gameState: GameState) {
		let highestCF = 0;
		let playersWithHighestCF: Player[] = [];

		for (const player of gameState.playerStateArray) {
			if (player.carbonFootprint > highestCF) {
				highestCF = player.carbonFootprint;
				playersWithHighestCF = [player];
			} else if (player.carbonFootprint === highestCF) {
				playersWithHighestCF.push(player);
			}
		}

		if (highestCF === 0) {
			return;
		}

		if (playersWithHighestCF.length === gameState.numPlayers) {
			return;
		}

		for (const player of playersWithHighestCF) {
			act_player.deleteFactory(player);
		}
	}

	noAction(_gameState: GameState) {}

	oilSpill(gameState: GameState) {
		if (gameState.carbonReservoir >= 3) {
			gameState.carbonReservoir -= 3;
			const lastId =
				gameState.currentTurnTypePlayerTableOrder[
					gameState.currentTurnTypePlayerTableOrder.length - 1
				];

			const player = getPlayerStateWithId(
				gameState.playerStateArray,
				lastId
			);
			player.carbonReserve += 3;
		} else {
			for (const p of gameState.playerStateArray) {
				p.factories--;
			}
		}
	}

	// PLAYER(S) WITH CARBON FOOTPRINTS FOUR (4) OR GREATER DISCARD THEIR HANDS IF THEY HAVE NO HAND TO DISCARD, LOSE A FACTORY
	oilThieves(gameState: GameState) {
		for (const player of gameState.playerStateArray) {
			// player.batteryEnergy = Math.max(player.batteries - player.carbonFootprint, player.batteryEnergy);
			if (player.carbonFootprint < 4) {
				continue;
			}
			if (player.seasonalCards.length > 0) {
				player.seasonalCards = [];
			} else {
				act_player.deleteFactory(player);
			}
		}
	}

	proTobacco(gameState: GameState) {
		let highestPR = 0;

		for (const player of gameState.playerStateArray) {
			highestPR = Math.max(highestPR, player.prArr.length);
		}

		for (const player of gameState.playerStateArray) {
			if (player.prArr.length === highestPR) {
				if (player.batteries < 6) {
					act_player.buyBattery(player);
				}
				act_player.refillAllBatteries(player);
			}
		}
	}

	rechargeAllBatteries(gameState: GameState) {
		for (const player of gameState.playerStateArray) {
			act_player.refillAllBatteries(player);
		}
	}

	rechargeAllBatteriesMinusCarbon(gameState: GameState) {
		for (const player of gameState.playerStateArray) {
			while (
				player.batteries - player.carbonFootprint >
				player.batteryEnergyArr.length
			) {
				act_player.refillBattery(player);
			}
		}
	}

	spinClass(gameState: GameState) {
		if (gameState.carbonReservoir < 10)
			for (const player of gameState.playerStateArray) {
				while (player.factoryEnergyArr.length > 0) {
					const fe = player.factoryEnergyArr.pop();
					if (fe) player.donationCupArr.push(fe);
				}
			}
	}

	superPac(gameState: GameState) {
		for (const player of gameState.playerStateArray) {
			if (player.carbonFootprint === 0) {
				continue;
			}
			if (player.prArr.length > 0) {
				player.prArr.pop();
			} else {
				player.batteries = Math.max(player.batteries - 1, 0);
			}
		}
	}

	tireFire(gameState: GameState) {
		console.log('TIRE FIRE');
		let highestCF = 0,
			secondCF = 0;
		const playersWithHighestCF: Player[] = [];
		const playersWithSecondCF: Player[] = [];

		for (const player of gameState.playerStateArray) {
			const cf = player.carbonFootprint;
			if (cf > highestCF) {
				secondCF = highestCF;
				highestCF = cf;
			} else if (cf > secondCF) {
				secondCF = cf;
			}
		}

		if (highestCF === 0) return;

		for (const p of gameState.playerStateArray) {
			if (p.carbonFootprint === highestCF) {
				playersWithHighestCF.push(p);
			} else if (secondCF > 0 && p.carbonFootprint === secondCF) {
				playersWithSecondCF.push(p);
			}
		}

		if (playersWithHighestCF.length === gameState.numPlayers) return;

		function tireFirePenalty(playerArr: Player[], highest: boolean) {
			for (let i = 0; i < playerArr.length; i++) {
				if (playerArr[i].prArr.length === 0) {
					act_player.deleteBattery(playerArr[i]);
				} else {
					playerArr[i].prArr.pop();
					if (playerArr[i].prArr.length > 0 && highest) {
						playerArr[i].prArr.pop();
					}
				}
			}
		}

		if (playersWithHighestCF.length > 0)
			tireFirePenalty(playersWithHighestCF, true);
		if (playersWithSecondCF.length > 0)
			tireFirePenalty(playersWithSecondCF, false);
		console.log('done');
	}

	zodiacKiller(gameState: GameState) {
		let highestCF = 0;
		let playersWithHighestCF: Player[] = [];

		for (const player of gameState.playerStateArray) {
			if (player.carbonFootprint > highestCF) {
				highestCF = player.carbonFootprint;
				playersWithHighestCF = [player];
			} else if (player.carbonFootprint === highestCF) {
				playersWithHighestCF.push(player);
			}
		}

		if (highestCF === 0) {
			return;
		}

		// if(playersWithHighestCF.length === gameState.numPlayers){
		//     return;
		// }

		for (const player of playersWithHighestCF) {
			if (player.prArr.length > 0) {
				player.prArr = [];
			} else {
				act_player.deleteFactory(player);
			}
		}
	}
}

export const news_action = new NewsAction();
